import { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";

import objectPath from "object-path";

import AsideLeft from "_metronic/layout/aside/AsideLeft";
import Header from "_metronic/layout/header/Header";
import HeaderMobile from "_metronic/layout/header/HeaderMobile";
// import Footer from '_metronic/layout/footer/Footer';
// import ScrollTop from 'app/partials/layout/ScrollTop';
// import StickyToolbar from 'app/partials/layout/StickyToolbar';
import HTMLClassService from "_metronic/layout/HTMLClassService";
import KtContent from "_metronic/layout/KtContent";
import LayoutConfig from "_metronic/layout/LayoutConfig";
import LayoutInitializer from "_metronic/layout/LayoutInitializer";
import MenuConfig from "_metronic/layout/MenuConfig";
import SubHeader from "_metronic/layout/sub-header/SubHeader";

import NotificationList from "app/partials/layout/NotificationList";

import "./assets/Base.scss";

const htmlClassService = new HTMLClassService();

function Layout({ children }) {
  // Redux selectors using useSelector hook
  const layoutConfig = useSelector((store) => store.builder.layoutConfig);
  const asideDisplay = useSelector((store) =>
    objectPath.get(store.builder.layoutConfig, "aside.self.display")
  );
  const subheaderDisplay = useSelector((store) =>
    objectPath.get(store.builder.layoutConfig, "subheader.display")
  );
  const isWorkspaceAccessOnHold = useSelector(
    (store) => store.workspaces.bootstrapStatus === "empty"
  );

  useEffect(() => {
    if (!isWorkspaceAccessOnHold) return;

    document.body.classList.remove(
      "kt-aside--enabled",
      "kt-aside--fixed",
      "kt-aside--minimize",
      "kt-aside--minimize-hover",
      "kt-aside--on"
    );
  }, [isWorkspaceAccessOnHold]);

  htmlClassService.setConfig(layoutConfig);
  // scroll to top after location changes
  // window.scrollTo(0, 0);

  // const contentCssClasses = htmlClassService.classes.content.join(" ");

  return (
    <LayoutInitializer
      menuConfig={MenuConfig}
      layoutConfig={LayoutConfig}
      htmlClassService={htmlClassService}
    >
      {/* <!-- begin:: Header Mobile --> */}
      {!isWorkspaceAccessOnHold && <HeaderMobile />}
      {/* <!-- end:: Header Mobile --> */}

      <div className="kt-grid kt-grid--hor kt-grid--root">
        {/* <!-- begin::Body --> */}
        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
          {/* <!-- begin:: Aside Left --> */}
          {asideDisplay && !isWorkspaceAccessOnHold && (
            <Fragment>
              <AsideLeft />
            </Fragment>
          )}
          {/* <!-- end:: Aside Left --> */}
          <div
            className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper"
            id="kt_wrapper"
          >
            <Header />

            {/* <!-- begin:: Content --> */}
            <div
              id="kt_content"
              className="pt-25px"
              // className={`kt-content ${contentCssClasses} kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor`}
            >
              {/* <!-- begin:: Content Head --> */}
              {subheaderDisplay && <SubHeader />}
              {/* <!-- end:: Content Head --> */}

              {/* <!-- begin:: Content Body --> */}
              <KtContent>{children}</KtContent>
              {/*<!-- end:: Content Body -->*/}
            </div>
            {/* <!-- end:: Content --> */}
            {/*<Footer />*/}
          </div>
        </div>
        {/* <!-- end:: Body --> */}
      </div>
      <NotificationList />
      {/* <ScrollTop /> */}
      {
        // <StickyToolbar />
      }
    </LayoutInitializer>
  );
}

export default Layout;
